/* eslint-disable no-undef */
import { markRaw } from 'vue';
export default {
	name: "dashboard",
	data() {
		return {
			customers: [],
			years: [],
			months: [],
			selectedStartDate: null,
			selectedEndDate: null,
			report:{
				startDate: null,
				endDate: null
			},
			selectedMonth: {
				name: null,
				id: null
			},
			selectedYear: {
				name: null,
				id: null
			},
			selectedOrderType: null,
			orderTypes: [],
			barChartXAxisName: null,
			productVolumePerDay: null,
			customerVolumePerDayData: null,
			totalAmountPerDayChartData: null,
			quantityOrderedPerOrderStatus: [],
			totalVolumePerStatusChartData: [],
			totalAmountPerStatusChartData: [],
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null,
			firstLoad: false,
			productVolumePerDayChart: null,
			productPricePerDayChart: null,
			customerVolumePerDayChart: null,
			totalVolumePerStatusChart: null,
			totalAmountPerStatusChart: null,
			hideClearButton: true,
			initialiseDatePicker: true,
			initialiseDatePickerEndDate: true,
			startDateHasChanged: false,
			endDateHasChanged: false,
			errorMessage: null
		};
	},
	methods: {
		getReportYearsAndMonths() {
			this.loading = true;
			reportService.getReportYearsAndMonths().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//this.years = successResponse.data.years;
						var self = this;
						var dateNow = new Date();
						var firstDayOfMonth = new Date(dateNow.getFullYear(), dateNow.getMonth(), 1).toLocaleDateString();
						var lastDayOfMonth = new Date(dateNow.getFullYear(), dateNow.getMonth() + 1, 0).toLocaleDateString();
						console.log("firstDayOfMonth", firstDayOfMonth);
						console.log("lastDayOfMonth", lastDayOfMonth);
						setTimeout(() => {
							self.selectedStartDate = firstDayOfMonth;
							self.selectedEndDate = lastDayOfMonth;
						}, 500);

						
						this.months = successResponse.data.months;

						this.months = $.map(this.months,
							function (obj) {
								obj.id = obj.id || obj.month;
								obj.text = obj.text || obj.name;
								return obj;
							}
						);

						for(let i = 0; i < successResponse.data.years.length; i++){
							let yearObj = {
								id: successResponse.data.years[i],
								text: successResponse.data.years[i].toString()
							};
							this.years.push(yearObj);
						}
						
						// this.years = $.map(this.years,
						// 	function (obj) {
						// 		obj.id =obj;
						// 		obj.text = obj;
						// 		return obj;
						// 	}
						// );
						this.selectedMonth.id = successResponse.data.currentMonth;
						this.selectedMonth.name = successResponse.data.currentMonthName;
						this.selectedYear.id = successResponse.data.currentYear;
						this.selectedYear.name = successResponse.data.currentYear.toString();
						this.getDashboard();
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDashboard(){
			if(this.selectedOrderType === orderHelper.orderType.delivery){
				this.getDeliveryOrderSummary();
			}
			else{
				this.getCollectionOrderSummary();
			}
		},
		getDeliveryOrderSummary(){
			this.loading = true;
			reportService.getDeliveryOrderSummary(this.selectedStartDate, this.selectedEndDate).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.productVolumePerDay = successResponse.data.volumePerDayChartData;
						this.totalAmountPerDayChartData = successResponse.data.totalAmountPerDayChartData;
						this.customerVolumePerDayData = successResponse.data.customerVolumePerDaySummaryChartData;
						this.totalVolumePerStatusChartData = successResponse.data.totalVolumePerStatusChartData;
						this.totalAmountPerStatusChartData = successResponse.data.totalAmountPerStatusChartData;
						console.log("productVolumePerDay", this.productVolumePerDay);
						var self = this;
						setTimeout(() => {
							if(self.productVolumePerDay !== null && self.productVolumePerDay !== undefined){
								self.buildProductVolumePerDayChart();
							}
							if(self.totalAmountPerDayChartData !== null && self.totalAmountPerDayChartData !== undefined){
								self.buildProductPricePerDayChart();
							}
							if(self.totalAmountPerStatusChartData !== null && self.totalAmountPerStatusChartData !== undefined){
								self.buildTotalAmountPerStatusChart();
							}
							if(self.totalVolumePerStatusChartData !== null && self.totalVolumePerStatusChartData !== undefined ){
								self.buildTotalQuantityPerOrderStatusChart();
							}
							if(self.customerVolumePerDayData !== null && self.customerVolumePerDayData !== undefined){
								self.buildCustomerVolumePerDayChart();
							}
						}, 500);
						
						this.firstLoad = true;
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCollectionOrderSummary(){
			this.loading = true;
			reportService.getCollectionOrderSummary(this.selectedStartDate, this.selectedEndDate).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.productVolumePerDay = successResponse.data.volumePerDayChartData;
						this.customerVolumePerDayData = successResponse.data.customerVolumePerDaySummaryChartData;
						this.totalAmountPerDayChartData = successResponse.data.totalAmountPerDayChartData;
						this.totalVolumePerStatusChartData = successResponse.data.totalVolumePerStatusChartData;
						this.totalAmountPerStatusChartData = successResponse.data.totalAmountPerStatusChartData;
						console.log("productVolumePerDay", this.productVolumePerDay);
						var self = this;
						setTimeout(() => {
							if(self.productVolumePerDay !== null && self.productVolumePerDay !== undefined){
								self.buildProductVolumePerDayChart();
							}
							if(self.totalAmountPerDayChartData !== null && self.totalAmountPerDayChartData !== undefined){
								self.buildProductPricePerDayChart();
							}
							if(self.totalAmountPerStatusChartData !== null && self.totalAmountPerStatusChartData !== undefined){
								self.buildTotalAmountPerStatusChart();
							}
							if(self.totalVolumePerStatusChartData !== null && self.totalVolumePerStatusChartData !== undefined ){
								self.buildTotalQuantityPerOrderStatusChart();
							}
							if(self.customerVolumePerDayData !== null && self.customerVolumePerDayData !== undefined){
								self.buildCustomerVolumePerDayChart();
							}
						}, 500);
						
						this.firstLoad = true;
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getOrderTypes(){
			this.orderTypes = orderService.getOrderTypes();
			this.orderTypes = $.map(this.orderTypes,
				function (obj) {
					obj.id = obj.id || obj.orderTypeId;
					obj.text = obj.text || obj.description;
					return obj;
				});
			this.selectedOrderType = this.orderTypes[0].id;
		},
		buildProductVolumePerDayChart() {
			let sourceData = [];
			let numberBars = this.productVolumePerDay.dimensions.length - 1;
			let series = [];
			for(let i = 0; i < this.productVolumePerDay.series.length; i++) {
				let sourceDataRow = [];
				let xAxisHeading = this.productVolumePerDay.series[i].name;
				sourceDataRow.push(xAxisHeading);
				for(let j = 0; j < this.productVolumePerDay.series[i].values.length; j++) {
					sourceDataRow.push(this.productVolumePerDay.series[i].values[j]);
				}
				sourceData.push(sourceDataRow);
			}
			for(let k = 0; k < numberBars; k++){
				series.push({ type: 'bar' });
			}
				
			console.log("sourceData", sourceData);
			let option = {
				legend: {},
				tooltip: {},
				dataset: {
					dimensions: this.productVolumePerDay.dimensions,
					source: sourceData
				},
				xAxis: {
					name: "Days",
					type: 'category'
				},
				yAxis: {
					type: "value",
					name: 'Litres'
				},
				// Declare several bar series, each will be mapped
				// to a column of dataset.source by default.
				series: series
			};
			if(this.productVolumePerDayChart === null){
				this.productVolumePerDayChart = markRaw(window.echarts.init(document.getElementById("productVolumePerDayChart"), theme));
			}
			this.productVolumePerDayChart.setOption(option, true);
			this.resizeEventForChart(this.productVolumePerDayChart);
		},
		buildProductPricePerDayChart() {
			let sourceData = [];
			let numberBars = this.totalAmountPerDayChartData.dimensions.length - 1;
			let series = [];
			for(let i = 0; i < this.totalAmountPerDayChartData.series.length; i++) {
				let sourceDataRow = [];
				let xAxisHeading = this.totalAmountPerDayChartData.series[i].name;
				sourceDataRow.push(xAxisHeading);
				for(let j = 0; j < this.totalAmountPerDayChartData.series[i].values.length; j++) {
					sourceDataRow.push(this.totalAmountPerDayChartData.series[i].values[j]);
				}
				sourceData.push(sourceDataRow);
			}
			for(let k = 0; k < numberBars; k++){
				series.push({ type: 'bar' });
			}

			console.log("sourceData", sourceData);
			let option = {
				legend: {},
				tooltip: {},
				calculable: true,
				dataset: {
					dimensions: this.totalAmountPerDayChartData.dimensions,
					source: sourceData
				},
				grid: [
					{
						right: "10%",
						left: "10%"
					}
				],
				xAxis: {
					name: "Days",
					type: 'category'
				},
				yAxis: {
					type: "value",
					name: 'Total Sales In Rands'
				},
				// Declare several bar series, each will be mapped
				// to a column of dataset.source by default.
				series: series
			};

			if(this.productPricePerDayChart === null){
				this.productPricePerDayChart = markRaw(window.echarts.init(document.getElementById("productPricePerDay"), theme));
			}
			this.productPricePerDayChart.setOption(option, true);
			this.resizeEventForChart(this.productPricePerDayChart);
		},
		buildCustomerVolumePerDayChart() {
			// let sourceData = [];
			// let numberBars = this.customerVolumePerDayData.dimensions.length - 1;
			// let series = [];
			// for(let i = 0; i < this.customerVolumePerDayData.series.length; i++) {
			// 	let sourceDataRow = [];
			// 	let xAxisHeading = this.customerVolumePerDayData.series[i].name;
			// 	sourceDataRow.push(xAxisHeading);
			// 	for(let j = 0; j < this.customerVolumePerDayData.series[i].values.length; j++) {
			// 		sourceDataRow.push(this.customerVolumePerDayData.series[i].values[j]);
			// 	}
			// 	sourceData.push(sourceDataRow);
			// }
			// for(let k = 0; k < numberBars; k++){
			// 	series.push({ type: 'bar' });
			// }
			//
			// console.log("sourceData", sourceData);
			// let option = {
			// 	legend: {},
			// 	tooltip: {},
			// 	calculable: true,
			// 	dataset: {
			// 		dimensions: this.customerVolumePerDayData.dimensions,
			// 		source: sourceData
			// 	},
			// 	grid: [
			// 		{
			// 			right: "10%",
			// 			left: "10%"
			// 		}
			// 	],
			// 	xAxis: {
			// 		name: "Days",
			// 		type: 'category'
			// 	},
			// 	yAxis: {
			// 		type: "value",
			// 		name: 'Litres'
			// 	},
			// 	// Declare several bar series, each will be mapped
			// 	// to a column of dataset.source by default.
			// 	series: series
			// };
			//
			// if(this.customerVolumePerDayChart === null){
			// 	this.customerVolumePerDayChart = markRaw(window.echarts.init(document.getElementById("customerVolumePerDayChart"), theme));
			// }
			// this.customerVolumePerDayChart.setOption(option, true);
			// this.resizeEventForChart(this.customerVolumePerDayChart);
			var option = {
				tooltip: {
					trigger: 'item'
				},
				legend: {
					orient: 'vertical',
					left: 'left'
				},
				series: [
					{
						type: 'pie',
						radius: '50%',
						data: this.customerVolumePerDayData,
						label: {
							show: false,
							formatter(param) {
								// correct the percentage
								return param.name + ' (' + param.value + 'L)';
							}
						},
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			};
			if(this.customerVolumePerDayChart === null){
				this.customerVolumePerDayChart = markRaw(window.echarts.init(document.getElementById("customerVolumePerDayChart"), theme));
			}
			this.customerVolumePerDayChart.setOption(option, true);
			this.resizeEventForChart(this.customerVolumePerDayChart);
		},
		buildTotalQuantityPerOrderStatusChart(){
			// need this to get half of the pie chart
			let total = 0;
			for(let i = 0; i < this.totalVolumePerStatusChartData.length; i++){
				total += this.totalVolumePerStatusChartData[i].value;
			}
			this.totalVolumePerStatusChartData.push(
				{
					// make an record to fill the bottom 50%
					value: total,
					itemStyle: {
						// stop the chart from rendering this piece
						color: 'none',
						decal: {
							symbol: 'none'
						}
					},
					label: {
						show: false
					}
				}
			);
			console.log("totalVolumePerStatusChartData", this.totalVolumePerStatusChartData);
			var option = {
				tooltip: {
					trigger: 'item'
				},
				legend: {
					top: '5%',
					left: 'center',
					// doesn't perfectly work with our tricks, disable it
					selectedMode: false
				},
				series: [
					{
						name: 'Total Volume Per Order Status',
						type: 'pie',
						radius: ['40%', '70%'],
						center: ['50%', '70%'],
						// adjust the start angle
						startAngle: 180,
						label: {
							show: false,
							formatter(param) {
								// correct the percentage
								return param.name + ' (' + param.percent + 'L)';
							}
						},
						data: this.totalVolumePerStatusChartData
					}
				]
			};
			if(this.totalVolumePerStatusChart === null){
				this.totalVolumePerStatusChart = markRaw(window.echarts.init(document.getElementById("totalVolumePerOrderStatus"), theme));
			}
			this.totalVolumePerStatusChart.setOption(option, true);
			this.resizeEventForChart(this.totalVolumePerStatusChart);
		},
		buildTotalAmountPerStatusChart(){
			// need this to get half of the pie chart
			let total = 0;
			for(let i = 0; i < this.totalAmountPerStatusChartData.length; i++){
				total += this.totalAmountPerStatusChartData[i].value;
			}
			this.totalAmountPerStatusChartData.push(
				{
					// make an record to fill the bottom 50%
					value: total,
					itemStyle: {
						// stop the chart from rendering this piece
						color: 'none',
						decal: {
							symbol: 'none'
						}
					},
					label: {
						show: false
					}
				}
			);
			var option = {
				tooltip: {
					trigger: 'item'
				},
				legend: {
					top: '5%',
					left: 'center',
					// doesn't perfectly work with our tricks, disable it
					selectedMode: false
				},
				series: [
					{
						name: 'Total Amount Per Order Status',
						type: 'pie',
						radius: ['40%', '70%'],
						center: ['50%', '70%'],
						// adjust the start angle
						startAngle: 180,
						label: {
							show: false,
							formatter(param) {
								// correct the percentage
								return param.name + ' ( R' + param.value + ' )';
							}
						},
						data: this.totalAmountPerStatusChartData
					}
				]
			};
			if(this.totalAmountPerStatusChart === null){
				this.totalAmountPerStatusChart = markRaw(window.echarts.init(document.getElementById("totalAmountPerOrderStatus"), theme));
			}
			this.totalAmountPerStatusChart.setOption(option, true);
			this.resizeEventForChart(this.totalAmountPerStatusChart);
		},
		resizeEventForChart(chart) {
			window.addEventListener("resize", function () {
				if (chart != null && chart != undefined) {
					chart.resize();
				}
			});
		},
		onDateFilterClearClick(){
			this.selectedStartDate = null;
			this.selectedEndDate = null;
		},
		onFromReportDateSelect(date){
			this.report.startDate = date;
		},
		onToReportDateSelect(date){
			this.report.endDate = date;
		},
		checkReportCollectionVolumeDispensed(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.checkReportCollectionVolumeDispensed(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					this.loading = false;
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.hasError){
							this.errorMessage = successResponse.data.message;
						}
						else{
							this.downloadReportCollectionVolumeDispensed();
						}
						this.loading = false;
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		checkReportDeliveryVarianceReport(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.checkReportDeliveryVarianceReport(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					this.loading = false;
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.hasError){
							this.errorMessage = successResponse.data.message;
						}
						else{
							this.downloadReportDeliveryVarianceReport();
						}
						this.loading = false;
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		checkReportExTankDispenseVarianceReport(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.checkReportExTankDispenseVarianceReport(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					this.loading = false;
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.hasError){
							this.errorMessage = successResponse.data.message;
						}
						else{
							this.downloadReportExTankDispenseVarianceReport();
						}
						this.loading = false;
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		downloadReportCollectionVolumeDispensed(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.downloadReportCollectionVolumeDispensed(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', "CollectionVolumeDispensedReport.xlsx");
					document.body.appendChild(link);
					link.click();
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		downloadReportDeliveryVarianceReport(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.downloadReportDeliveryVarianceReport(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', "DeliveryVarianceReport.xlsx");
					document.body.appendChild(link);
					link.click();
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		downloadReportExTankDispenseVarianceReport(){
			this.errorMessage = null;
			if(this.report.startDate === null || this.report.endDate === null){
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				startDate: this.report.startDate,
				endDate: this.report.endDate
			};
			orderService.downloadReportExTankDispenseVarianceReport(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', "ExTankDispenseVarianceReport.xlsx");
					document.body.appendChild(link);
					link.click();
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
        downloadOverdueCustomerPaymentsReport(){
            this.errorMessage = null;
            if(this.report.startDate === null || this.report.endDate === null){
                this.errorMessage = "Please select a date range";
                return;
            }
            this.loading = true;
            let request = {
                startDate: this.report.startDate,
                endDate: this.report.endDate
            };
            customerService.downloadCustomersWithOverduePaymentsReport(request).then(
                successResponse => {
                    console.log("successResponse", successResponse);
                    const url = window.URL.createObjectURL(new Blob([successResponse.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', "CustomersWithOverduePaymentsReport.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    this.loading = false;
                },
                errorResponse => {
                    console.log("errorResponse", errorResponse);
                    this.loading = false;
                    apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
                }
            );
        },
        downloadPricingReport(){
            this.errorMessage = null;
            if(this.report.startDate === null || this.report.endDate === null){
                this.errorMessage = "Please select a date range";
                return;
            }
            this.loading = true;
            let request = {
                startDate: this.report.startDate,
                endDate: this.report.endDate
            };
            orderService.getPricingReport(request).then(
                successResponse => {
                    console.log("successResponse", successResponse);
                    const url = window.URL.createObjectURL(new Blob([successResponse.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', "PricingReport.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    this.loading = false;
                },
                errorResponse => {
                    console.log("errorResponse", errorResponse);
                    this.loading = false;
                    apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
                }
            );
        },
        downloadReportVolumePerDepotByDateRange(){
            this.errorMessage = null;
            if(this.report.startDate === null || this.report.endDate === null){
                this.errorMessage = "Please select a date range";
                return;
            }
            this.loading = true;
            let request = {
                startDate: this.report.startDate,
                endDate: this.report.endDate,
                depotIds: null // null means all depots
            };
            orderService.downloadReportVolumePerDepotByDateRange(request).then(
                successResponse => {
                    console.log("successResponse", successResponse);
                    const url = window.URL.createObjectURL(new Blob([successResponse.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', "VolumePerDepotReport.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    this.loading = false;
                },
                errorResponse => {
                    console.log("errorResponse", errorResponse);
                    this.loading = false;
                    apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
                }
            );
        },
        downloadVolumeByCustomerDepotShippingAddress(){
            this.errorMessage = null;
            if(this.report.startDate === null || this.report.endDate === null){
                this.errorMessage = "Please select a date range";
                return;
            }
            this.loading = true;
            let request = {
                companyIds: null, // null means all companies
                depotIds: null, // null means all depots
                shippingAddressIds: null, // null means all shipping addresses
                fromDate: this.report.startDate,
                toDate: this.report.endDate,
                orderTypeId: null, // null means all order types
                orderStatusId: null // null means all order statuses
            };
            orderService.downloadVolumeByCustomerDepotShippingAddress(request).then(
                successResponse => {
                    console.log("successResponse", successResponse);
                    const url = window.URL.createObjectURL(new Blob([successResponse.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', "VolumeByCustomerDepotShippingAddress.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    this.loading = false;
                },
                errorResponse => {
                    console.log("errorResponse", errorResponse);
                    this.loading = false;
                    apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
                }
            );
        },
		onFromDateCreatedSelect(date) {
			this.selectedStartDate = date;
			this.startDateHasChanged = true;
			this.initialiseDatePicker = false;
			if(this.selectedStartDate !== null && this.selectedEndDate !== null && this.startDateHasChanged && this.endDateHasChanged){
				// if(this.firstLoad){
				// 	this.getDashboard();
				// }
				this.getDashboard();
			}
		},
		onToDateCreatedSelect(date) {
			this.selectedEndDate = date;
			this.endDateHasChanged = true;
			this.initialiseDatePickerEndDate = false;
			if(this.selectedStartDate !== null && this.selectedEndDate !== null){
				// if(this.firstLoad){
				// 	this.getDashboard();
				// }
				this.getDashboard();
			}
		},
		onMonthSelect(month) {
			this.selectedMonth.id = month.id;
			this.selectedMonth.name = month.text;
			if(this.firstLoad){
				this.getDashboard();
			}
		},
		onYearSelect(year) {
			this.selectedYear.id = year.id;
			this.selectedYear.name = year.text;
			if(this.firstLoad){
				this.getDashboard();
			}
		},
		onOrderTypeFilterSelect(orderType) {
			this.selectedOrderType = orderType.id;
			if(this.firstLoad){
				this.getDashboard();
			}
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Dashboard");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Dashboard");
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getOrderTypes();
		console.log("mounted");
		//this.getReportYearsAndMonths();
		var self = this;
		var sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
		console.log("sevenDaysAgo", sevenDaysAgo);
		var dateNow = new Date();
		setTimeout(() => {
			self.selectedStartDate = sevenDaysAgo;
			self.selectedEndDate = dateNow;
		}, 500);
		//this.getDashboard();
	},
	unmounted: function () {
		if(this.productVolumePerDayChart !== null){
			this.productVolumePerDayChart.dispose();
		}
		if(this.productPricePerDayChart !== null){
			this.productPricePerDayChart.dispose();
		}
		if(this.totalVolumePerStatusChart !== null){
			this.totalVolumePerStatusChart.dispose();
		}
		if(this.totalAmountPerStatusChart !== null){
			this.totalAmountPerStatusChart.dispose();
		}
		if(this.customerVolumePerDayChart !== null){
			this.customerVolumePerDayChart.dispose();
		}
	}
};